/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1064
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.Explicit = "explicitly_set"
  e.Sampler = "client_sampler"
  e.Rate = "client_rate"
  e.Inheritance = "inheritance"
})(r || (r = {}))
export default r
